import { render, staticRenderFns } from "./LandingPageLayout.vue?vue&type=template&id=152414e2&scoped=true&"
import script from "./LandingPageLayout.vue?vue&type=script&lang=js&"
export * from "./LandingPageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152414e2",
  null
  
)

export default component.exports